/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_No_Spaces_FoundInputs */



/**
* | output |
* | --- |
* | "No dataset spaces found" |
*
* @param {Datasets_No_Spaces_FoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_no_spaces_found = /** @type {((inputs?: Datasets_No_Spaces_FoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_No_Spaces_FoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Datensatz-Bereiche gefunden")
	return /** @type {LocalizedString} */ ("No dataset spaces found")
});